import { load } from "@shopify/theme-sections";
import { add, listen, qs } from "@fluorescent/dom";
import isMobile from "is-mobile";

import pageTransition from "@/lib/page-transition";
import modal from "@/lib/modal";
import storeAvailabilityDrawer from "@/lib/store-availability-drawer";
import { handleTab } from "@/lib/a11y";
import sectionClasses from "@/lib/section-classes";
import { hydrate, on } from "@/glow/events";
import quickProductModal from "@/lib/quick-product-modal";
// import { initQuickAddFilters, initQuickAddModalCounts } from "@/lib/quick-add"; /* Removing until quick add modal can be fleshed out. */
import productLightbox from "@/lib/product-lightbox";
import widthWatch from "@/lib/width-watcher";

import { flashAlertModal } from "@/lib/flash-alert";
import headerOverlay from "@/lib/header-overlay";
import backToTop from "@/lib/back-to-top";
import { cart } from "@/glow";

// Import sections
import "@/sections";

// eslint-disable-next-line no-prototype-builtins
if (!HTMLElement.prototype.hasOwnProperty("inert")) {
  import(flu.chunks.polyfillInert);
}

// Detect theme editor
if (window.Shopify.designMode === true) {
  add(document.documentElement, "theme-editor");
  document.documentElement.classList.add("theme-editor");
} else {
  const el = qs(".theme-editor-scroll-offset", document);
  el && el.parentNode.removeChild(el);
}

// Function to load all sections
const loadSections = () => {
  load("*");
  hydrate({ SelectedProductSection: null });
};

// Call above function either immediately or bind on loaded event
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  loadSections();
} else {
  listen(document, "DOMContentLoaded", loadSections);
}

if (isMobile({ tablet: true, featureDetect: true })) {
  add(document.body, "is-mobile");
}

// Page transitions
pageTransition();

// a11y tab handler
handleTab();

// Apply contrast classes
sectionClasses();

// Load productlightbox
productLightbox();

// widthWatch breakpoint emmiter
widthWatch();

// Product quick view/add modal
const quickProductModalElement = qs("[data-quick-product-modal]", document);

if (quickProductModalElement) {
  quickProductModal(quickProductModalElement);
}

// Load quick add modal
// Removing until quick add modal can be fleshed out.
// const quickAddHasVariants = qs(
//   ".product-item__quick-add-wrapper[data-has-variants]",
//   document
// );

// if (quickAddHasVariants) {
//   initQuickAddFilters();
//   initQuickAddModalCounts();
// }

// Setup modal
const modalElement = qs("[data-modal]", document);
modal(modalElement);

const flashModal = qs("[data-flash-alert]", document);
flashAlertModal(flashModal);

// Product availabilty drawer
const availabilityDrawer = qs("[data-store-availability-drawer]", document);
storeAvailabilityDrawer(availabilityDrawer);

// Setup header overlay
const headerOverlayContainer = document.querySelector("[data-header-overlay]");
headerOverlay(headerOverlayContainer);

// Init back to top button
backToTop();

// Maintain a local representation of the cart accessible to JS
cart.get().then(cartData => {
  window.theme.cartData = cartData;
});
on("cart:updated", responseData => {
  window.theme.cartData = responseData.cart;
});

// Make it easy to see exactly what theme version
// this is by commit SHA

window.SHA = "__gitSHA";

if (
  !sessionStorage.getItem("flu_stat_recorded") &&
  !window.Shopify?.designMode
) {
  // eslint-disable-next-line no-process-env
  fetch(process.env.FLU_STATS_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...window.theme.coreData,
      s: window.Shopify?.shop,
      r: window.Shopify?.theme?.role,
    }),
  });

  if (window.sessionStorage) {
    sessionStorage.setItem("flu_stat_recorded", "true");
  }
}
